import { atom } from 'recoil';

export const fiscalCreditFee = atom({
  key: 'fiscalCreditFee',
  default: undefined,
});